import { useContentRoute } from './useContentRoute';

/**
 * Utility hook a route to the home page.
 */
export const useHomeRoute = () => useContentRoute({ isHomePage: true }).route;
